import { render, staticRenderFns } from "./SearchResultTabsAttractions.vue?vue&type=template&id=52c8e984&"
import script from "./SearchResultTabsAttractions.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsAttractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports